import VueLuzmoLib from "@luzmo/vue-embed";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VueLuzmoLib);
});
